import { COLOR_SET_CLASSES, customTV } from '../../utils/tailwind';
export const alert = customTV({
    base: 'flex flex-row items-start gap-12 rounded-sm p-16 border',
    variants: {
        severity: {
            info: [...COLOR_SET_CLASSES.info.default.background, ...COLOR_SET_CLASSES.info.default.border],
            error: [...COLOR_SET_CLASSES.critical.default.background, ...COLOR_SET_CLASSES.critical.default.border],
            warning: [...COLOR_SET_CLASSES.warning.default.background, ...COLOR_SET_CLASSES.warning.default.border],
            success: [...COLOR_SET_CLASSES.success.default.background, ...COLOR_SET_CLASSES.success.default.border],
        },
    },
    defaultVariants: {
        severity: 'error',
    },
});
export const iconWrapper = customTV({
    base: 'flex h-20 justify-center',
});
export const actionsContainer = customTV({
    base: [
        'mt-8',
        '[&_button]:text-content-default-dark [&_button]:dark:text-content-default [&_button]:relative',
        'hover:[&_button]:bg-gradient-to-r hover:[&_button]:from-[#000]/20 hover:[&_button]:to-[#000]/20',
        'focus:[&_button]:bg-gradient-to-r focus:[&_button]:from-[#000]/20 focus:[&_button]:to-[#000]/20 ',
        'focus:[&_button]:scale-95 focus:[&_button]:transition-transform hover:[&_button]:transition-colors focus:[&_button]:transition-colors [&_button]:duration-200 [&_button]:ease-in-out',
    ],
    variants: {
        severity: {
            info: [
                '[&_button]:bg-content-info [&_button]:dark:bg-content-info-dark',
                'hover:[&_button]:bg-content-info hover:[&_button]:dark:bg-content-info-dark',
                'focus:[&_button]:bg-content-info focus:[&_button]:dark:bg-content-info-dark',
            ],
            error: [
                '[&_button]:bg-content-critical [&_button]:dark:bg-content-critical-dark',
                'hover:[&_button]:bg-content-critical hover:[&_button]:dark:bg-content-critical-dark',
                'focus:[&_button]:bg-content-critical focus:[&_button]:dark:bg-content-critical-dark',
            ],
            warning: [
                '[&_button]:bg-content-warning [&_button]:dark:bg-content-warning-dark',
                'hover:[&_button]:bg-content-warning hover:[&_button]:dark:bg-content-warning-dark',
                'focus:[&_button]:bg-content-warning focus:[&_button]:dark:bg-content-warning-dark',
            ],
            success: [
                '[&_button]:bg-content-success [&_button]:dark:bg-content-success-dark',
                'hover:[&_button]:bg-content-success hover:[&_button]:dark:bg-content-success-dark',
                'focus:[&_button]:bg-content-success focus:[&_button]:dark:bg-content-success-dark',
            ],
        },
    },
    defaultVariants: {
        severity: 'error',
    },
});
